import React, { useState } from "react";
import Modal from "./Modal";
import { imageUrl } from "../../../constants/constants";

const DirectorInformationCard = ({ director }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);

  const handleModalOpen = () => {
    setIsModalVisible(true);
  };

  const handleModalClose = () => {
    setIsModalVisible(false);
  };

  return (
    <div className="col-12 col-sm-12 col-md-4 col-lg-3 print-director">
      <div
        className="card"
        onClick={handleModalOpen}
        tabIndex="0"
        aria-label={`View details of ${director.title}`}
      >
        <div className="dir_img">
          <img
            className="card-img-top"
            src={imageUrl + director?.field_director_image}
            alt={director.title}
            style={{ width: "100%" }}
          />
        </div>
        <div className="card-body">
          <h2 className="card-title">{director.title}</h2>

          <div className="card-text">
            <small>
              <div
                dangerouslySetInnerHTML={{
                  __html: director.field_designation_of_director_bo,
                }}
              ></div>
              <div
                dangerouslySetInnerHTML={{
                  __html: director.field_sub_designation,
                }}
              ></div>
            </small>
            <small>{director.field_address_board_directoer}</small>
            <small>{director.field_phone_number_director}</small>
            {/* <small>Shillong-793003</small> */}
          </div>
          {/* <button type="button" className="quick-btn" onClick={handleModalOpen}>
            View Profile
          </button> */}
        </div>
      </div>
      <Modal
        isVisible={isModalVisible}
        onClose={handleModalClose}
        content={director}
        ariaLabel={`Detailed information about ${director.title}`}
      />
    </div>
  );
};

export default DirectorInformationCard;
